export default function fullOrgUrl(rest = '') {
  return `https://${window.__slab.PUBLIC_ORG.effectiveHost}${rest}`;
}
